import GrainTypeDto from './GrainType'
import QualityTypeDto from './QualityType'
import PackagingTypeDto from './PackagingType'

let CommodityDto = {
  id: -1,
  qualityType: QualityTypeDto,
  grainType: GrainTypeDto,
  packagingType: PackagingTypeDto,
  bagQuantity: 0,
  amount: 0,
  locationInPlant: null,
  harvesting: null,
  gramaje: null,
  owner: null,
  obs: null,
  bagQtyStock: null
}

export default CommodityDto
